<script lang="ts">
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	import MainEnergyMeterPicker from './shared/MainEnergyMeterPicker.svelte';

	import { ButtonV2, Modal } from '@Shelly/shelly-design-system';

	export let show = false;
	export let loading = false;
	export let initialDeviceId: string | null = null;
	export let isEdit = false;

	const dispatch = createEventDispatcher<{
		close: void;
		save: { deviceId: string };
	}>();

	let selectedDeviceId: string | null = null;

	$: canSave = Boolean(selectedDeviceId);
	$: modalTitle = isEdit
		? $format('title_change_main_energy_meter', { default: 'Change main energy meter' })
		: $format('title_add_energy_meter_to_home', { default: 'Add Main Energy Meter to home' });
	$: if (show) {
		selectedDeviceId = initialDeviceId;
	}

	const handleClose = (): void => {
		dispatch('close');
	};

	const handleSave = (): void => {
		if (!selectedDeviceId) return;
		dispatch('save', { deviceId: selectedDeviceId });
	};
</script>

<Modal showModal={show} title={modalTitle} backdropClose={false} on:close={handleClose}>
	<div slot="content">
		<MainEnergyMeterPicker idPrefix="home-main-em" bind:selectedDeviceId />
	</div>

	<div slot="footer" class="d-flex justify-content-end gap-s">
		<ButtonV2
			variant="secondary"
			aria-label={$format('button_cancel', { default: 'Cancel' })}
			disabled={loading}
			on:click={handleClose}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</ButtonV2>
		<ButtonV2
			aria-label={$format('button_save', { default: 'Save' })}
			disabled={!canSave || loading}
			{loading}
			class="min-width-md-m min-width-sm-auto"
			on:click={handleSave}
		>
			{$format('button_save', { default: 'Save' })}
		</ButtonV2>
	</div>
</Modal>
